import { EstateUpsellMetaType } from '/@/modules/estateupsell/constants/EstateUpsellMetaType';
import { EstateUpsellClearWillMeta } from '/@/modules/estateupsell/models/metas/EstateUpsellClearWillMeta';
import { EstateUpsellClearEstateMeta } from '/@/modules/estateupsell/models/metas/EstateUpsellClearEstateMeta';

export class EstateUpsellMeta {
  /**
   * @param model
   * @returns {EstateUpsellClearEstateMeta|EstateUpsellClearWillMeta|null}
   */
  static factory(model) {
    switch (model.metaType) {
      case EstateUpsellMetaType.ESTATE_UPSELL_CLEAR_WILL_META:
        return EstateUpsellClearWillMeta.mapModel(model.meta);
      case EstateUpsellMetaType.ESTATE_UPSELL_CLEAR_ESTATE_META:
        return EstateUpsellClearEstateMeta.mapModel(model.meta);
      default:
        return null;
    }
  }
}
